import { GTMPageType } from 'modules/gtm/constants';
import { currentBasketInitialData } from 'modules/gtm/modules/sections/cart/data';
import { ClientPageType } from 'src/app/types';
import { push } from '../../common';
import { CurrentBasket, GTMProductParsed } from '../../types';

export const gtmPushViewCart = (data: GTMProductParsed[], currency: string) => {
  push({
    event: 'Ecommerce - View cart',
    event_name: 'view_cart',
    view_cart: {
      step_number: '1',
      items: data,
      currency,
    },
  });
};

export const gtmPushRemoveFromCart = (
  data: GTMProductParsed | null,
  currency: string,
  pageType?: ClientPageType,
) => {
  push({
    event: 'Ecommerce - Remove from cart',
    event_name: 'remove_from_cart',
    remove_from_cart: {
      currency: currency,
      items: [data],
      remove_from_cart_location: pageType && GTMPageType[pageType],
    },
  });
};

export const gtmPushAddToCart = (
  data: GTMProductParsed | null,
  currency: string,
  pageType?: ClientPageType,
) => {
  push({
    event: 'Ecommerce - Add to cart',
    event_name: 'add_to_cart',
    add_to_cart: {
      currency: currency,
      items: [data],
      add_to_cart_location: pageType && GTMPageType[pageType],
    },
  });
};

export const gtmCurrentBasket = (data: CurrentBasket | null) => {
  push({
    event: 'Generic Event',
    event_name: 'currentBasket',
    currentBasket: data || currentBasketInitialData,
  });
};
